
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consignment",
      function () {
        return require("private-next-pages/consignment/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consignment"])
      });
    }
  